export default function CScanf() {
  return <h2>C Scanf</h2>;
}
